import React from 'react';
import { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import axios from "axios";
import DoneMessages from "../Utils/DoneMessage";
import { SpinnerCircular } from "spinners-react";
import Cookies from "universal-cookie";
const cookie = new Cookies();
function SignInOauthGoogle() {
  const google = window.google;

  const [text, setText] = useState("");
  const [code, setCode] = useState(200);
  const [messageView, setMessageView] = useState(false);
  const [spinnerView, setspinnerView] = useState(false);

  function handleCallbackResponse(response) {
    setMessageView(false);
    var userObjects = jwtDecode(response.credential);
    const data = { email: userObjects.email };
    document.getElementById("signGoogle").hidden = true;
    setspinnerView(true);
    axios
      .post(
        "https://ferias-ingenio-backend.vercel.app/api/users/getGoogleUser",
        data
      )
      .then((res) => {
        console.log(res.data);
        if (res.data.code == 200) {
          setCode(res.data.code);
          setText(res.data.message);
          setMessageView(true);
          cookie.set("id", res.data.doc.id, { path: "/" });
          cookie.set("username", res.data.doc.username, { path: "/" });
          cookie.set("email", res.data.doc.email, { path: "/" });
          cookie.set("likes", res.data.doc.likes, { path: "/" });
          if (!res.data.doc.admin) {
            if (!res.data.doc.judge) {
              window.location.href = "/categories";
            } else {
              window.location.href = "/judges";
              cookie.set("judge", res.data.doc.judge, { path: "/" });
            }
          } else {
            window.location.href = "/administration";
            cookie.set("admin", res.data.doc.admin, { path: "/" });
          }
        } else {
          setCode(res.data.code);
          setText(res.data.message);
          setMessageView(true);
          document.getElementById("signGoogle").hidden = false;
          setspinnerView(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  useEffect(() => {
    try {
      google.accounts.id.initialize({
        client_id:
          "712764576912-kprd2qg3di2db1b53llcsn6ga8hjeu2b.apps.googleusercontent.com",
        callback: handleCallbackResponse,
      });
    } catch (err) {
      window.location.reload();
      console.log("Arregladon...");
    }

    google.accounts.id.renderButton(document.getElementById("signGoogle"), {
      theme: "outline",
      size: "medium",
      text: "signin_with",
    });
  }, [messageView, spinnerView]);

  return (
    <div className="App">
      <div id="signGoogle"></div>
      {spinnerView && <SpinnerCircular secondaryColor="#fff" />}
      {messageView && <DoneMessages text={text} code={code} />}
    </div>
  );
}

export default SignInOauthGoogle;
